import React from "react";
import styled, { createGlobalStyle } from "styled-components";
import { IntervalSettings } from "./components/Settings/IntervalSettings";
import { TimerDisplay } from "./components/Timer/TimerDisplay";
import { TimerControls } from "./components/Timer/TimerControls";
import { RunningMap } from "./components/Map/RunningMap";
import { StatsPanel } from "./components/Stats/StatsPanel";
import { useTimer } from "./hooks/useTimer";
import { useGeolocation } from "./hooks/useGeolocation";
import { useTrainingStore } from "./stores/trainingStore";

// 1. 글로벌 스타일 정의
const GlobalStyle = createGlobalStyle`
  :root {
    --bg-dark: #0A0A0B;
    --card-bg: #1C1C1E;
    --accent-run: #FF3B30;
    --accent-walk: #30D158;
    --text-main: #FFFFFF;
    --text-sub: #8E8E93;
  }
  body {
    background-color: var(--bg-dark);
    color: var(--text-main);
    font-family: -apple-system, BlinkMacSystemFont, "SF Pro Display", sans-serif;
    margin: 0;
    display: flex;
    justify-content: center;
  }
  * { box-sizing: border-box; }
`;

const AppContainer = styled.div`
  width: 100%;
  max-width: 480px;
  min-height: 100vh;
  padding: 20px;
  display: flex;
  flex-direction: column;
`;

const Header = styled.header`
  padding: 20px 0;
  text-align: center;
  h1 {
    font-size: 1.5rem;
    font-weight: 800;
    letter-spacing: -1px;
  }
`;

const App: React.FC = () => {
  useTimer();
  useGeolocation();
  const { isActive, totalDistance } = useTrainingStore();

  return (
    <>
      <GlobalStyle />
      <AppContainer>
        <Header>
          <h1>INTERVAL RUNNER</h1>
        </Header>

        {!isActive && <IntervalSettings />}

        <TimerDisplay />
        <TimerControls />

        <RunningMap />
        <StatsPanel />

        {!isActive && totalDistance > 0 && (
          <SummaryCard>
            <h2>Great Job! 🎉</h2>
            <p>Total: {(totalDistance / 1000).toFixed(2)} km</p>
          </SummaryCard>
        )}
      </AppContainer>
    </>
  );
};

const SummaryCard = styled.div`
  background: var(--card-bg);
  padding: 30px;
  border-radius: 24px;
  margin-top: 20px;
  text-align: center;
  border: 1px solid var(--accent-walk);
`;

export default App;
